import { lazy } from 'react'
import { RouteObject } from 'react-router-dom'

const DataSyncTenantListing = lazy(() => import('../components/DataSyncTenantListing'))
const EtpSyncWorkspace = lazy(() => import('../components/EtpSyncWorkspace'))
const FeedConfigPage = lazy(() => import('../components/FeedConfigPage'))
const EtpSyncDocsPage = lazy(() => import('../../EtpSyncDocs/EtpSyncDocsPage'))

export const DataSyncListingRoute: RouteObject = {
    path: 'data-sync',
    element: <DataSyncTenantListing />,
}

export const DataSyncDocsRoute: RouteObject = {
    path: 'data-sync/docs/:chapterSlug?',
    element: <EtpSyncDocsPage />,
}

export const EtpSyncWorkspaceRoute: RouteObject = {
    path: 'tenants/:tenantId/etp-sync/:buId',
    element: <EtpSyncWorkspace />,
}

export const EtpSyncWorkspaceIndexRoute: RouteObject = {
    path: 'tenants/:tenantId/etp-sync',
    element: <EtpSyncWorkspace />,
}

export const EtpSyncFeedConfigRoute: RouteObject = {
    path: 'tenants/:tenantId/etp-sync/:buId/:feedSlug',
    element: <FeedConfigPage />,
}
